module.exports = __webpack_public_path__ + "assets/images/grid/green-xmas-6.jpg?v=bd6c458c";